import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '@store'
import { User } from '@apis/index'
import Table from '@components/table'
import { eye, switchOff, switchOn, totalusers } from '@assets/icons'
import { Helper } from '@utils'
import Svg from '@components/svg'
import { useModal } from '@context/ModalContext'
import UserDetailModal from '@commons/user-detail-modal'

const ContactPerson = () => {
  const { showModal } = useModal()
  const {
    items: users,
    loading,
    totalItems,
    totalPages,
  } = useSelector((state: RootState) => state.users)
  const [page] = useState(1)
  const fetchUsers = async () => {
    await User.list({
      state: 'users',
      params: { page, limit: 20, role: 'user' },
    })
  }

  const column = [
    { title: 'Contact Person name', key: 'name', render: (item) => item.name },
    { title: 'Mobile Number', key: 'number', render: (item) => item.phoneNo },
    {
      title: 'Address',
      key: 'address',
      render: (item) => item.address || 'N/A',
    },
    {
      title: 'Created Date',
      key: 'date',
      render: (item) => (
        <>
          <p>{Helper.formatDate(item.createdAt)}</p>
          <p>{Helper.formatTime(item.createdAt)}</p>
        </>
      ),
    },
    {
      title: 'Status',
      key: 'status',
      render: (item) => (
        <Svg
          src={item.isActive ? switchOn : switchOff}
          onClick={async () => {
            await User.updateStatus({
              state: 'users',
              id: item.id,
              data: { isActive: !item.isActive },
            })
          }}
        />
      ),
    },
  ]
  useEffect(() => {
    fetchUsers()
  }, [page])
  return (
    <>
      <br />
      <Table
        text={'contact Person'}
        icon={totalusers}
        columns={column}
        data={users}
        totalPages={totalPages}
        totalItems={totalItems}
        loading={loading}
        actions={[
          {
            key: 'view',
            icon: eye,
            onClick: (item) => {
              showModal(<UserDetailModal item={item} />)
            },
          },
        ]}
      />
    </>
  )
}

export default ContactPerson
